import { render, staticRenderFns } from "./checkRFeature.vue?vue&type=template&id=70903f14"
import script from "./checkRFeature.vue?vue&type=script&lang=js"
export * from "./checkRFeature.vue?vue&type=script&lang=js"
import style0 from "./checkRFeature.vue?vue&type=style&index=0&id=70903f14&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports